module.exports = __webpack_public_path__ + "director_instructions_full_1.png?07366cdbd9615106752a03264343154f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/director_instructions_full_1.png
// module id = 466
// module chunks = 0